import { useEffect, useState } from 'react';
import { useBlockchainProvider } from '../Blockchain/blockchainProvider';
import { ethers } from 'ethers';
import { createStandaloneToast } from '@chakra-ui/react';

export const useReflink = () => {
	const { account } = useBlockchainProvider();
	const [reflink, setReflink] = useState<string | null>(null);

	const { toast } = createStandaloneToast();

	useEffect(() => {
		setReflink(localStorage.getItem('buddy') ?? (account as string));
	}, [account]);

	const copy = async (tokenAddress: string) => {
		if (account === ethers.constants.AddressZero) {
			toast({ title: 'Log in to generate a referral link' });
			return;
		}

		const reflink = `${window.location.protocol}//${window.location.host}/game/${tokenAddress}/?buddy=${account}`;
		await navigator.clipboard.writeText(reflink);
	};

	return {
		copyReflink: copy,
		getReflink: reflink,
	};
};
